module.exports = __webpack_public_path__ + "static/media/ObservationCognition.19b15cc7.jpg";